import { useMediaQuery, useTheme } from "@mui/material";

interface UseMediaQueryBreakpointReturn {
  mobileThreshold: number;
  tabletThreshold: number;
  desktopThreshold: number;
  desktopXlThreshold: number;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isDesktopXl: boolean;
  betweenMobileAndTablet: boolean;
  betweenTabletAndDesktop: boolean;
  betweenDesktopAndDesktopXl: boolean;
}

export function useMediaQueryBreakpoint(): UseMediaQueryBreakpointReturn {
  const theme = useTheme();

  const mobileThreshold = theme.breakpoints.values.mobile;
  const tabletThreshold = theme.breakpoints.values.tablet;
  const desktopThreshold = theme.breakpoints.values.desktop;
  const desktopXlThreshold = theme.breakpoints.values.desktopXl;

  const isMobile = useMediaQuery(theme.breakpoints.up("mobile"));
  const isTablet = useMediaQuery(theme.breakpoints.up("tablet"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("desktop"));
  const isDesktopXl = useMediaQuery(theme.breakpoints.up("desktopXl"));

  const betweenMobileAndTablet = useMediaQuery(
    theme.breakpoints.between("mobile", "tablet"),
  );
  const betweenTabletAndDesktop = useMediaQuery(
    theme.breakpoints.between("tablet", "desktop"),
  );
  const betweenDesktopAndDesktopXl = useMediaQuery(
    theme.breakpoints.between("desktop", "desktopXl"),
  );

  return {
    mobileThreshold,
    tabletThreshold,
    desktopThreshold,
    desktopXlThreshold,
    isMobile,
    isTablet,
    isDesktop,
    isDesktopXl,
    betweenMobileAndTablet,
    betweenTabletAndDesktop,
    betweenDesktopAndDesktopXl,
  };
}
